// Which shared filter controls each reports page shows. The shell (index.js)
// renders all of them once, above the page, so they stay put across page
// switches; this module only decides where each one appears.

// Pages that show the shared date FilterBar. A page belongs here when its
// data is windowed to the shared range. Static explainers (methodology),
// builders (export, exec summary) and the fixed-window pages (factor-detail)
// do their own thing and would be confused by a shared date range. Users IS
// date-bearing: the roster's engagement columns (sims sent, click rate, 2nd
// stage, reported, courses sent, completion, avg score) window to the selected
// range; only the risk score / band stay on the fixed 180-day snapshot. Sim and
// course detail window their KPIs and recipients too, so the period mustn't be
// hidden there (BD-1170). The drill-down tables (all sims, all courses, high
// click users, outstanding users) window their rows to the shared range, so
// they show it too (NBD-26).
export const DATE_BEARING_PAGES = new Set([
    'sims', 'courses', 'dwm', 'users', 'user-detail', 'meta-list', 'meta-detail', 'sim-detail', 'course-detail',
    'send-history', 'course-send-log', 'flagged-sims',
    'all-sims-table', 'all-courses-table', 'outstanding-users', 'performance',
]);

// Pages that apply the shared scope (tenancy, department, location, city,
// country, state, company, user). Every one shows the "Slice by" chip row with
// a User chip, and the active-filter pills, so a filter the page applies is
// always visible and editable there (BD-1112). Risk takes only the tenancy, the
// detail pages are about one item, and the export pages build their own scope.
export const SCOPED_PAGES = new Set([
    'sims', 'courses', 'users', 'performance', 'flagged-sims', 'meta-list',
    'all-sims-table', 'all-courses-table', 'send-history', 'course-send-log', 'outstanding-users',
]);

// Scoped pages that also filter by simulation or by course get that chip too.
export const SIM_CHIP_PAGES = new Set(['sims', 'all-sims-table', 'send-history']);
export const COURSE_CHIP_PAGES = new Set(['courses', 'all-courses-table', 'course-send-log', 'outstanding-users']);

// Pages that show the active-filter pill strip: the scoped pages, plus Risk for
// its tenancy filter.
export const ACTIVE_FILTER_PAGES = new Set([...SCOPED_PAGES, 'summary']);
